import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from '@mui/material';
import React from 'react';

type Props = MuiSwitchProps;

export const WO2ToggleSwitch = (props: Props): JSX.Element => <MuiSwitch disableRipple={true} {...props} />;
